module.exports = __webpack_public_path__ + "img/icon-zoom-out.f3b86de5.svg";